import { AosModal } from './aos-modal';

export { AosModal };
